<template>
  <section class="section" v-if="getUserEbooks && getUserEbooks.length > 0">
    <h1 class="title">
      Continue Reading
    </h1>
    <b-table :data="getUserEbooks" :loading="isLocalLoading">
      <template slot-scope="props">
        <b-table-column field="title" label="Title" width="280">
          {{ props.row.title }}
        </b-table-column>
        <b-table-column field="author" label="Author" width="150">
          {{ props.row.author }}
        </b-table-column>
        <b-table-column label="Progress" width="100">
          {{ props.row.playOrder }} / {{ props.row.numberOfSections }}
        </b-table-column>
        <b-table-column label="%" width="100">
          <progress class="progress is-primary" :value="props.row.playOrder" :max="props.row.numberOfSections"></progress>
        </b-table-column>
        <b-table-column label="Completed" width="100">
          <span v-if="props.row.isCompleted">✅</span>
          <span v-else>❌</span>
        </b-table-column>
        <b-table-column width="150">
          <button type="button" class="button is-white" @click="sendEmail(props.row.id, props.row.sectionId)">
            Send email
          </button>
        </b-table-column>
      </template>
      <template slot="footer">
        <div class="has-text-right">
            {{ getEbooksCount }}
        </div>
      </template>
    </b-table>
    <p v-if="getNotCompletedUserEbooksCount === 0">
      You're not currently reading a book, <a href="/#/">start reading now</a>!
    </p>
  </section>
  <section class="section" v-else>
    You're not reading a book yet, <a href="/#/">start reading now</a>!
  </section>
</template>

<script>
export default {
  name: 'userEbooksList',
  mounted () {
    this.$store.dispatch('getUserEbooks')
  },
  methods: {
    sendEmail (ebookId, sectionId) {
      const user = this.isAuthenticated
      if (user) {
        this.$store.dispatch('reSendChapter', { ebookId, sectionId, user: user.id })
      }
    }
  },
  computed: {
    getEbooksCount () {
      const ebooks = this.$store.getters.getUserEbooks
      if (ebooks) {
        const count = ebooks.length
        if (count === 1) {
          return '1 ebook'
        } else {
          return `${count} ebooks`
        }
      }
      return 'no ebook'
    },
    getNotCompletedUserEbooksCount () {
      const userEbooks = this.$store.getters.getUserEbooks
      if (userEbooks && userEbooks.length > 0) {
        return userEbooks.filter(e => !e.isCompleted).length
      }
      return 0
    },
    getUserEbooks () {
      return this.$store.getters.getUserEbooks
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'userEbooksList' && localLoading.active
    }
  }
}
</script>

<style>

</style>
